<template>
    <div
        v-cloak
        class="grid-menu casting-menu alchemy"
    >
        <ul>
            <li>
                <a
                    href="/casting/santiago"
                    title="Santiago">
                    <img
                        src="/static/casting/img/santiago-cover.jpg"
                        alt="Santiago" />
                    <span>Sebastian de Souza<small>"Santiago"</small></span>
                </a>
            </li>
            <li>
                <a
                    href="/casting/fatima"
                    title="Fatima">
                    <img
                        src="/static/casting/img/fatima-cover.jpg"
                        alt="Fatima" />
                    <span>Selin Akkulak<small>"Fatima"</small></span>
                </a>
            </li>
            <li>
                <a
                    href="/casting/the-englishman"
                    title="Charles Godfrey">
                    <img
                        src="/static/casting/img/englishman-cover.jpg"
                        alt="The Englishman" />
                    <span>Tom Hollander<small>"Charles Godfrey"</small></span>
                </a>
            </li>
            <li>
                <a
                    href="/casting/the-crystal-merchant"
                    title="Zahara">
                    <img
                        src="/static/casting/img/crystal-cover.jpg"
                        alt="The Crystal Merchant" />
                    <span>Shohreh Aghdashloo<small>"Zahara"</small></span>
                </a>
            </li>
            <li>
                <a
                    href="/casting/camel-driver"
                    title="Bassam">
                    <img
                        src="/static/casting/img/cameldriver-cover.jpg"
                        alt="Camel Driver 'Bassam'" />
                    <span>Youssef Kerkour<small>"Bassam"</small></span>
                </a>
            </li>
            <li>
                <a
                    href="/casting/santiagos-father"
                    title="Pedro">
                    <img
                        src="/static/casting/img/santiagosfather-cover.jpg"
                        alt="Santiago's Father" />
                    <span>Jordi Mollà<small>"Pedro"</small></span>
                </a>
            </li>
            <li>
                <a
                    href="/casting/akram"
                    title="Akram">
                    <img
                        src="/static/casting/img/akram-cover.jpg"
                        alt="Akram" />
                    <span>Ashraf Barhom<small>"Akram"</small></span>
                </a>
            </li>
            <li>
                <a
                    href="javascript:void(0);"
                    title="Tribal Leader">
                    <img
                        src="/static/casting/img/triballeader-cover.jpg"
                        alt="Tribal Leader" />
                    <span>Younes Bouab<small>"Tribal Leader"</small></span>
                </a>
            </li>
            <li>
                <a
                    href="javascript:void(0);"
                    title="Ruffian">
                    <img
                        src="/static/casting/img/ruffian-cover.jpg"
                        alt="Tribal Leader" />
                    <span>Aymen Hamdouchi<small>"Ruffian"</small></span>
                </a>
            </li>
            <li>
                <a
                    href="javascript:void(0);"
                    title="Tribal Leader">
                    <img
                        src="/static/casting/img/nadim-cover.jpg"
                        alt="Tribal Leader" />
                    <span>Madi Belem<small>"Nadim"</small></span>
                </a>
            </li>
            <li class="tbd">
                <a
                    href="javascript:void(0);"
                    title="The King">
                    <img
                        src="/static/casting/img/tbd-cover.png"
                        alt="The King" />
                    <span>Old Man<em>TBD</em></span>
                </a>
            </li>
            <li class="tbd">
                <a
                    href="javascript:void(0);"
                    title="The Alchemist">
                    <img
                        src="/static/casting/img/tbd-cover.png"
                        alt="The Alchemist" />
                    <span>The Alchemist<em>TBD</em></span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    import auth from '../utils/auth';

    export default {
        name: 'team',
        data() {
            return {
                isAnAlchemist: typeof window !== 'undefined' && auth.currentUser()
            };
        },
        created() {
            const self = this;
            if (self.isAnAlchemist) {
                self.alchemistRole = auth.currentUser().app_metadata.roles[0];
            }
        }
    };
</script>

<style scoped>
    .casting-menu {
        text-align: center;

        ul {
            grid-template-columns: repeat(4, 1fr);

            li:not(.tbd) a span {
                @mixin position absolute, auto, 2.5%, 8%, 2.5%;
                @mixin transform translateY(0);
            }
        }

        &.santiago {
            ul {
                li {
                    a {
                        text-decoration: none;

                        &::before {
                            display: none !important;
                        }

                        img {
                            border-radius: 20px;
                        }

                        span {
                            @mixin position relative, auto, auto, auto, auto;
                            @mixin transform translateY(0);
                            color: var(--color-black);
                            display: block;
                            margin: 5px 0 0;
                            text-shadow: 0 0 var(--color-white);
                        }

                        &:hover,
                        &:active {
                            img {
                                transform: scale(.93);
                            }

                            span {
                                color: var(--color-alchemist-red);
                            }
                        }
                    }
                }
            }
        }

        &.alchemy {
            ul {
                grid-template-columns: repeat(3, 1fr);
            }
        }

        @media (--breakpoint-xl-max) {
            ul {
                grid-template-columns: repeat(4, 1fr);

                li {
                    max-width: none;
                }
            }
        }

        @media (--breakpoint-l-max) {
            ul {
                li {
                    max-width: none;
                }
            }
        }

        @media (--breakpoint-m-max) {
            ul,
            &.alchemy ul, {
                grid-template-columns: repeat(2, 1fr);
            }
        }

        @media (--breakpoint-s-max) {
            ul,
            &.alchemy ul, {
                grid-template-columns: repeat(1, 1fr);
            }
        }
    }
</style>
